/* ════════════════════════════════════════════════════════════════
   MAISON ART PILATES — Animations au scroll (vanilla, léger)
   Toute classe .maison-anim-fadeup ou .maison-anim-floatin
   sera animée quand elle entre dans le viewport.
   ════════════════════════════════════════════════════════════════ */

(function () {
  'use strict';

  // Respect preference utilisateur
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    document.querySelectorAll('.maison-anim-fadeup, .maison-anim-floatin')
      .forEach(el => el.classList.add('is-visible'));
    return;
  }

  const supportsIO = 'IntersectionObserver' in window;

  if (!supportsIO) {
    // Fallback : affiche tout immédiatement
    document.querySelectorAll('.maison-anim-fadeup, .maison-anim-floatin')
      .forEach(el => el.classList.add('is-visible'));
    return;
  }

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      }
    });
  }, {
    threshold: 0.12,
    rootMargin: '0px 0px -50px 0px'
  });

  function observeAll() {
    document.querySelectorAll(
      '.maison-anim-fadeup:not(.is-visible), .maison-anim-floatin:not(.is-visible)'
    ).forEach(el => observer.observe(el));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observeAll);
  } else {
    observeAll();
  }

  // Réobserve après changements dynamiques (ex : section ajoutée dans l'éditeur Shopify)
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', observeAll);
  }
})();
